import { render, staticRenderFns } from "./MenuTab.vue?vue&type=template&id=41f24d64"
import script from "./MenuTab.vue?vue&type=script&lang=js"
export * from "./MenuTab.vue?vue&type=script&lang=js"
import style0 from "./MenuTab.vue?vue&type=style&index=0&id=41f24d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports